import { createContext, useLayoutEffect, useEffect, useRef, useState } from "react"
import styled from "@emotion/styled"
import { useDictionary } from "contexts/Dictionary"
import getMediaQuery from "css/breakpoints"
import { body50, bold, light, legend100, legend80, headline30, legend110, body100, body70 } from "css/text"
import { LAUNCH_ROUTE, UPDATE_ROUTE, KILL_ROUTE } from "./../../model/model-variations/constants"
import { WatchVariationsContextProvider, useWatchVariations, mvSubscribe } from "./../../model/model-variations/context"
import ModelVariations from "./ModelVariations"
import { FooterPrice } from "./../../model/model-variations/Footer"
import { buttonReset } from "css/buttons"
import { useWatchgrid } from "./../context"
import Image from "components/media/ImageCLD"
import { FixedPrice } from "components/price/Price"

const Item = styled.li`
  position: relative;
  overflow: hidden;
  background: rgb(var(--light-grey));
  --gv-padding-inline: 5vw;

  ${getMediaQuery("l")} {
    --gv-padding-inline: 2vw;
  }
`

export const ShowVariations = styled.button`
  ${buttonReset}
  ${legend80}
  ${bold}
  aspect-ratio: 1/1;
  width: 5rem;

  img {
    width: 100%;
    height: auto;
  }

  span {
    margin-block-start: -.75rem;
//    font-size: .9em;
    display: grid;
  }

  .no-js & {
    display: none;
  }

  ${getMediaQuery("m")} {
    width: 8rem;
    ${legend110}
    span {
     margin-block-start: -1.5rem;
     font-size: .9em;
    }
  }
  ${getMediaQuery("l")} {
    width: 6rem;
    ${legend100}
    span {
     margin-block-start: -.75rem;
    }
  }
  ${getMediaQuery("xxll")} {
    width: 7.5rem;
    ${legend100}
    span {
     margin-block-start: -1.5rem;
    }
  }
`

export const CardCover = styled.div`
  grid-area: 1/-1;
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: opacity 600ms cubic-bezier(1,1,1,1) 300ms, visibility 0ms 0ms;
  visibility: visible;
  will-change: opacity, visibility;
  z-index: 1;
  pointer-events: none;
  display: flex;
  height: 100%;

  & button {
    pointer-events: auto;
  }

  &.wv_hide {
    opacity: 0;
    visibility: hidden;
    transition: opacity 100ms cubic-bezier(.32,.94,.6,1) 0ms, visibility 0ms 100ms;
  }

  section {
    position: relative;
    box-sizing: border-box;
    display: flex;
  }

  section:nth-of-type(1) {
    padding-inline: var(--gv-padding-inline) 0;
    width: 33%;
    align-items: center;

    h2 {
      ${legend110}
      ${bold}

      span {
        margin-block-start: 8px;
        display: block;
        ${legend100}
        ${light}
      }
    }
    > div {
      p {
        ${legend100}
        ${light}
        padding-block: .2rem 0;
        display: flex;
        gap: 0;
        position: relative;
        white-space: nowrap;
        & button {
        transform: scale(.9);
          position: relative;
          &::after {
            content: "";
            position: absolute;
            padding: 1rem;
            box-sizing: border-box;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
          }
        }
      }
    }
    ${getMediaQuery("m")} {
      width: 37%;
      h2 {
        ${body50}
      }
    }
    
    ${getMediaQuery("l")} {
     > div p {
        & button {
            transform: scale(1);
        }
      }
    }

    ${getMediaQuery("xxll")} {
    }
  }

  section:nth-of-type(2) {
    flex: 1;
    align-self: center;
    justify-content: end;
    padding-inline: 0 6vw;
    padding-block: 5rem 0;

    ${getMediaQuery("s")} {
      padding-inline: 0 8vw;
    }
    ${getMediaQuery("m")} {
      padding-inline: 0 6vw;
      padding-block: 8rem 0;
    }
    ${getMediaQuery("l")} {
      padding-inline: 0 var(--gv-padding-inline);
      padding-block: 0;
    }
    ${getMediaQuery("xl")} {
      padding-inline: 0 4vw;
    }
  }
`

function WatchCardContents({ ctx, price }) {
  const { route, incard, entry, active, reset, wa } = useWatchVariations(ctx)
  const { selected, weave, thematic } = useWatchgrid()

  function onSelection(v) {
    //    console.log("bbb onSelection", v)
    if (v === incard) open()
  }
  useLayoutEffect(() => mvSubscribe("WatchCardContents selected", selected, onSelection, false), [])

  function onVariationsClick(e) {
    selected.set(incard)
  }

  function open() {
    //    console.log("bbb open")
    route.set(LAUNCH_ROUTE)
    /*
    waTriggerEvent({
      eventName: "viewVariationsCTA",
      productFamily: props.familyNode?.code,
      productRMC: rmc,
      position: "cover model",
    })*/
  }

  function onFocusClick(e) {
    //    console.log("bbb onFocusClick")
    const _active = active.get()
    entry.set(_active)
    //    fromui.set(true)
    weave(incard, _active)
    reset.set(null)
    selected.set(null)
    wa({}, true, false, true)
  }

  return (
    <ModelVariations ctx={ctx} onFocusClick={onFocusClick}>
      <WatchCardCover ctx={ctx} thematic={thematic} handleClick={onVariationsClick} price={price} />
    </ModelVariations>
  )
}

function WatchCardCover({ ctx, handleClick }) {
  const dictionary = useDictionary()
  const rfmain = useRef()
  const { route, entry, getModel, variations, pricelist, incard } = useWatchVariations(ctx)
  const pid = incard.replace("/", "_")
  //  console.log("WatchCardCover variations", variations)
  const [label, setLabel] = useState(null)
  const [picture, setPicture] = useState(null)
  const [fprice, setFprice] = useState()
  //  const novars = !+getModel(entry.get())?.sindex?.join("") > 0

  function showHide(hide) {
    //    console.log("bbb WatchCardCover showHide", incard, hide)
    rfmain.current?.classList[hide ? "add" : "remove"]("wv_hide")
  }

  function onRoute(v) {
    //    console.log("bbb WatchCardCover onRoute", incard, v)
    showHide(!!v)
    if (!v) onEntry(entry.get())
  }
  useLayoutEffect(() => mvSubscribe("ModelMajestyContents route", route, onRoute), [])

  function buildPicture(variationsCtaImage) {
    let variationsCtaImageJson = null
    try {
      variationsCtaImageJson = variationsCtaImage ? JSON.parse(variationsCtaImage) : null
    } catch (e) { }

    const variationsCtaImageProps = variationsCtaImageJson?.length ? variationsCtaImageJson[0] : null
    const variationsCtaImagePicture = variationsCtaImageProps
      ? {
        public_id: variationsCtaImageProps.src,
        version: 1,
        path: variationsCtaImageProps.path,
        policy: variationsCtaImageProps.policy,
        width: 120,
        height: 120,
      }
      : null

    return variationsCtaImagePicture
  }

  function onEntry(v) {
    if (!v || !!route.get()) return
    const m = getModel(v)
    if (!m) return
    //    console.log("bbb onEntry m", m)
    setLabel(`${m.specs[3]}<span>${m.specs[0]}</span>`)
    setPicture(buildPicture(m.variationsCtaImage_cl))
    setFprice({
      formattedPrice: pricelist.get(v),
      pricePopin: pricelist.get("pricePopin")
    })
  }
  useEffect(() => mvSubscribe("WatchCardContents entry", entry, onEntry), [])

  return (
    <CardCover ref={rfmain}>
      <section>
        <div>
          <h2 dangerouslySetInnerHTML={{ __html: label }} id={pid} />
          <FixedPrice {...fprice} ariaDescribedBy={pid} />
        </div>
      </section>
      {variations?.filter(v => !!v.length)?.length ? (
        <section>
          <ShowVariations className="wv-show-variations" onClick={handleClick}>
            {picture && <Image loading='eager' alt='' sizes='20vw' sources={[picture]} aria-hidden='true' />}
            <span>{dictionary.viewVariations()}</span>
          </ShowVariations>
        </section>
      ) : null}
    </CardCover>
  )
}

export default function WatchCard({ uid, cardid, familyCode, variations, getModel, pricelist }) {
  const ctx = createContext(null)
  //  console.log("WatchCard", cardid, variations)

  return (
    <Item>
      <WatchVariationsContextProvider
        Ctx={ctx}
        entry={uid}
        active={uid}
        route={KILL_ROUTE}
        family={familyCode}
        getModel={getModel}
        variations={variations}
        mode='cover'
        incard={cardid}
        pricelist={pricelist}
      >
        <WatchCardContents ctx={ctx} />
      </WatchVariationsContextProvider>
    </Item>
  )
}
